import {Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {OccupationFrequency} from "../../../../domain/enums/occupation-freq.enum";
import {PropertyStatusEnum} from "../../../../domain/enums/property-status.enum";
import {EnrollmentType, EnrollmentTypeStrMap} from "../../../../domain/enums/enrollment-type.enum";
import {Icons} from "../../../../domain/enums/icons-enums";
import {
  EnrollmentTypeIndicatorComponent
} from "../../../../common/enrollment-type-indicator/enrollment-type-indicator.component";
import {StatusIndicatorComponent} from "../../../../common/status-indicator/status-indicator.component";
import {MatTableModule} from "@angular/material/table";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatFormFieldModule, MatSuffix} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {CommonModule} from "@angular/common";
import {MatChipsModule} from "@angular/material/chips";
import {MatTooltipModule} from "@angular/material/tooltip";
import {RouterModule} from "@angular/router";
import {FilterTagContainerComponent} from "../../../../common/filter-tag-container/filter-tag-container.component";
import {FrequencyPipe} from "../../../../common/frequency-pipe/frequency.pipe";
import {PropertyTypePipe} from "../../../../common/property-type-pipe/property-type.pipe";

@Component({
  selector: 'app-property-search-filter',
  standalone: true,
  imports: [EnrollmentTypeIndicatorComponent, StatusIndicatorComponent, MatTableModule,
    FormsModule, MatIconModule, MatButtonModule, MatInputModule, MatPaginatorModule,
    MatSortModule, MatFormFieldModule, MatSelectModule, MatSuffix, CommonModule,
    MatChipsModule, MatTooltipModule, RouterModule, StatusIndicatorComponent, FilterTagContainerComponent,
    FrequencyPipe, PropertyTypePipe],
  templateUrl: './property-search-filter.component.html',
  styleUrl: './property-search-filter.component.css'
})
export class PropertySearchFilterComponent {
  @Output() filterChanged = new EventEmitter<Map<string,string>>();
  @ViewChild(FilterTagContainerComponent) filterContainer!: FilterTagContainerComponent;
  userTypes = Object.keys(EnrollmentType);
  filterColumns = ['accountType', 'status', 'frequency', 'keyword'];
  filters= new Map<string, string>();
  queryStatus: string = "";
  queryOccupation: string = "";
  queryCustomerType: string = "";
  query = "";
  protected readonly OccupationFrequency = OccupationFrequency;
  protected readonly propertyStatusEnum = PropertyStatusEnum;
  protected readonly EnrollmentTypeStrMap = EnrollmentTypeStrMap;
  protected readonly icons = Icons;

  onFilter(colIdx: number, value: string) {
    this.filters.set(this.filterColumns[colIdx], value);
    this.filterChanged.emit(this.filters);
    if(value) {
      this.filterContainer.addFilterTag({
        value: value,
        type: this.filterColumns[colIdx],
        label: value,
        icon: value.toLocaleLowerCase() + '-icon'
      });
    } else {
      this.filterContainer.removeTag({
        value: value,
        type: this.filterColumns[colIdx],
        label: value
      });
    }
  }

  clearSearch() {
    this.query = "";
    this.onFilter(3, '');
  }

  removeFilter(event: { value: string, type: string }) {
    switch (event.type) {
      case this.filterColumns[0]:
        this.queryCustomerType = "";
        this.filterContainer.removeTag({
          value: this.queryCustomerType,
          type: this.filterColumns[0],
          label: this.queryCustomerType
        });
        this._removeFilter(0);
        break;
      case this.filterColumns[1]:
        this.queryStatus = "";
        this.filterContainer
          .removeTag({
            value: this.queryStatus,
            type: this.filterColumns[1],
            label: this.queryStatus
          });
        this._removeFilter(1);
        break;
      case this.filterColumns[2]:
        this.queryOccupation = "";
        this.filterContainer.removeTag({
          value: this.queryOccupation,
          type: this.filterColumns[2],
          label: this.queryOccupation
        });
        this._removeFilter(2);
        break;
      case this.filterColumns[3]:
        this.query = "";
        this.filterContainer.removeTag({
          value: this.query,
          type: this.filterColumns[3],
          label: this.query
        });
        this._removeFilter(3);
        break;
    }
  }

  _removeFilter(colIdx: number) {
    this.filters.delete(this.filterColumns[colIdx]);
    this.filterChanged.emit(this.filters);
  }

  removeFilters() {
    this.queryStatus = "";
    this.queryOccupation = "";
    this.queryCustomerType = "";
    this.query = "";
    this.filters.clear();
    this.filterChanged.emit(this.filters);
  }

}
